export default "__VITE_ASSET__44SuR6PV__"